class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) return;
    this.content = this.mainDetailsToggle.querySelector('summary')?.nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut(event) {
    // Delay + relatedTarget check: avoids instant close when summary is clicked
    // (some browsers briefly move focus to <body> and used to collapse the Shop menu).
    const next = event.relatedTarget;
    if (next && this.contains(next)) return;
    setTimeout(() => {
      if (!this.mainDetailsToggle?.open) return;
      if (this.contains(document.activeElement)) return;
      // Still open and hovering inside (desktop dropdown) — keep open
      if (this.matches(':hover') || this.querySelector(':hover')) return;
      this.close();
    }, 180);
  }

  onToggle() {
    if (!this.content) return;
    if (!this.animations) this.animations = this.content.getAnimations?.() || [];

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play?.());
    } else {
      this.animations.forEach((animation) => animation.cancel?.());
    }
  }

  close() {
    if (!this.mainDetailsToggle) return;
    this.mainDetailsToggle.removeAttribute('open');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.sectionHeader = document.querySelector('.section-header');
  }

  onToggle() {
    if (this.header) {
      this.header.preventHide = this.mainDetailsToggle?.open;
    }
    // Raise header stacking while a desktop dropdown is open so the panel
    // is not painted under the hero / page sections.
    if (this.sectionHeader) {
      this.sectionHeader.classList.toggle('elevate-nav-open', !!this.mainDetailsToggle?.open);
    }
    if (!this.header) return;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
